module.exports = __webpack_public_path__ + "static/media/grace.0153345e.jpg";